import styled from 'styled-components'

export const LoaderWrapper = styled.div`
  width: 1.75rem;
  height: 1.75rem;

  > div {
    position: absolute;
    left: -2.25rem;
    top: -2.25rem;
    transform: scale(0.5);
  }
`

LoaderWrapper.displayName = 'LoaderWrapper'

export const CommentSuggestionOptions = styled.div`
  gap: var(--spacer-2);
`

CommentSuggestionOptions.displayName = 'CommentSuggestionOptions'

export const CommentSuggestionOption = styled.button`
  transition: background-color ease 250ms;
  background-color: transparent;

  &:hover {
    background-color: var(--gray-200);
  }
`

CommentSuggestionOption.displayName = 'CommentSuggestionOption'
